export default __webpack_public_path__ + "static/banner-home-2ffb478994a2ead0acda132d425aa39f.jpg";